import { Check, Edit, Trash2, Eye, FileText, Download, IndianRupee } from 'lucide-react';
import { TableActionButton } from '@/components/ui';
import { formatInstallationTrade } from '../../verve-teams/utils/teamMemberLabels';

export const TEAM_COLUMNS = (onDelete, locked, expensesMap = {}, formatCurrency = (v) => v, onViewTransactions, onExportTransactions, onRequestExpense, siteName = '', onEdit) => [
  {
    header: 'Name',
    key: 'name',
    render: (row) => (
      <div className="flex flex-col justify-center">
        <span className="text-[13px] font-medium text-slate-700 font-['Poppins']">{row.name || 'Member'}</span>
        {row.phone && <span className="text-[11px] text-slate-500 font-medium font-['Poppins']">{row.phone}</span>}
      </div>
    )
  },
  {
    header: 'Role Type',
    key: 'installationTrade',
    render: (row) => (
      <span className="text-[12px] font-medium text-slate-600 font-['Poppins']">
        {row.installationTrade ? formatInstallationTrade(row.installationTrade) : (row.role ? formatInstallationTrade(row.role) : '—')}
      </span>
    )
  },
  /* {
    header: 'Customer Verve ID',
    key: 'projectId',
    render: () => (
      <span className="text-[12px] font-medium text-slate-600 font-['Poppins']">{siteName || '—'}</span>
    )
  }, */
  {
    header: 'Actions',
    key: 'actions',
    className: 'w-[100px]',
    render: (row) => (
      <div className="flex items-center gap-1">
        {onEdit && (
          <button
            type="button"
            title="Edit Member"
            onClick={() => !locked && onEdit(row)}
            disabled={locked}
            className={`flex items-center justify-center w-8 h-8 rounded-md transition-colors ${locked ? 'text-slate-200 cursor-not-allowed' : 'text-slate-400 hover:bg-blue-50 hover:text-blue-600 cursor-pointer'
              }`}
          >
            <Edit className="w-4 h-4" />
          </button>
        )}
        <button
          type="button"
          title="Remove Member"
          onClick={() => !locked && onDelete(row)}
          disabled={locked}
          className={`flex items-center justify-center w-8 h-8 rounded-md transition-colors ${locked ? 'text-slate-200 cursor-not-allowed' : 'text-slate-300 hover:bg-rose-50 hover:text-rose-500 cursor-pointer'
            }`}
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    )
  }
];

export const TASK_COLUMNS = (onView, onEdit) => [
  {
    header: 'Task Details',
    key: 'taskName',
    className: "font-['Poppins'] text-[13px] font-medium text-slate-700"
  },
  {
    header: 'Assigned Officer',
    key: 'assignedOfficer',
    render: (row) => (
      <span className="text-[12px] font-medium text-slate-600 font-['Poppins']">{row.assignedOfficer?.name || '—'}</span>
    )
  },
  {
    header: 'Department',
    key: 'installationTrade',
    render: (row) => (
      <span className="text-[11px]  tracking-tight text-slate-500">
        {row.installationTrade ? formatInstallationTrade(row.installationTrade) : '—'}
      </span>
    )
  },
  {
    header: 'Status',
    key: 'status',
    render: (row) => (
      <span className={`px-2 py-0.5 rounded text-[9px] font-black uppercase border tracking-widest ${row.status === 'COMPLETED' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-blue-50 text-blue-600 border-blue-100'
        }`}>
        {row.status?.replace('_', ' ')}
      </span>
    )
  },
  {
    header: 'Progress',
    key: 'progress',
    render: (row) => (
      <div className="flex items-center gap-3">
        <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden min-w-[60px]">
          <div className="h-full bg-[#2b448f]" style={{ width: `${row.progress || 0}%` }} />
        </div>
        <span className="text-[11px] font-bold text-[#2b448f] tabular-nums">{row.progress || 0}%</span>
      </div>
    )
  },
  {
    header: 'Actions',
    key: 'actions',
    className: 'w-[100px] text-right pr-4',
    render: (row) => (
      <div className="flex items-center justify-end gap-1">
        <button
          type="button"
          onClick={() => onView && onView(row)}
          className="flex items-center justify-center w-8 h-8 rounded-lg text-slate-300 hover:bg-blue-50 hover:text-[#2b448f] transition-all cursor-pointer group"
          title="View Task Details"
        >
          <Eye className="w-4 h-4 group-hover:scale-110 transition-transform" />
        </button>
        <button
          type="button"
          onClick={() => onEdit && onEdit(row)}
          className="flex items-center justify-center w-8 h-8 rounded-lg text-slate-300 hover:bg-blue-50 hover:text-[#f97316] transition-all cursor-pointer group"
          title="Edit Task"
        >
          <Pencil className="w-4 h-4 group-hover:scale-110 transition-transform" />
        </button>
      </div>
    )
  }
];

export const TRANSACTION_COLUMNS = (formatCurrency, formatRowDateTime) => [
  {
    header: 'Site Name',
    key: 'siteName',
    className: "text-[12px] font-medium text-slate-700 font-['Poppins'] whitespace-nowrap"
  },
  {
    header: 'Payment Type',
    key: 'expenseType',
    render: (row) => (
      <span className="px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-[10px] font-bold uppercase tracking-tight whitespace-nowrap">
        {row.expenseType}
      </span>
    )
  },
  {
    header: 'Description',
    key: 'description',
    className: "text-[12px] font-medium text-slate-600 font-['Poppins'] min-w-[200px]"
  },
  {
    header: 'Amount',
    key: 'amount',
    render: (row) => (
      <span className={`text-[13px] font-semibold font-['Poppins'] ${row.amountClass}`}>
        ₹{formatCurrency(row.amount)}
      </span>
    )
  },
  {
    header: 'Date & Time',
    key: 'date',
    render: (row) => (
      <span className="text-[12px] font-medium text-slate-500 font-['Poppins'] whitespace-nowrap">
        {formatRowDateTime(row.date)}
      </span>
    )
  }
];

export const EXPENSE_COLUMNS = (formatCurrency, formatRowDateTime) => [
  {
    header: 'Role Type',
    key: 'roleType',
    render: (row) => (
      <span className="text-[11px] font-bold text-slate-600 uppercase tracking-tight">
        {row.roleType}
      </span>
    )
  },
  {
    header: 'Site Name',
    key: 'siteName',
    className: "text-[12px] font-medium text-slate-700 font-['Poppins'] whitespace-nowrap"
  },
  {
    header: 'Expense Type',
    key: 'expenseType',
    render: (row) => (
      <span className="px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-[10px] font-bold uppercase tracking-tight whitespace-nowrap">
        {row.expenseType}
      </span>
    )
  },
  {
    header: 'Description',
    key: 'description',
    className: "text-[12px] font-medium text-slate-600 font-['Poppins'] min-w-[200px]"
  },
  {
    header: 'Amount',
    key: 'amount',
    render: (row) => (
      <span className={`text-[13px] font-semibold font-['Poppins'] ${row.amountClass}`}>
        ₹{formatCurrency(row.amount)}
      </span>
    )
  },
  {
    header: 'Date & Time',
    key: 'date',
    render: (row) => (
      <span className="text-[12px] font-medium text-slate-500 font-['Poppins'] whitespace-nowrap">
        {formatRowDateTime(row.date)}
      </span>
    )
  }
];

export const DOCUMENT_COLUMNS = (onDownload, onView, onDelete, onApprove, currentUser) => [
  {
    header: 'Document Name',
    key: 'originalName',
    className: "text-[12px] font-medium text-slate-700 font-['Poppins']",
    render: (row) => (
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded bg-slate-50 flex items-center justify-center text-slate-400 border border-slate-100">
          <FileText className="w-4 h-4" />
        </div>
        <div className="flex flex-col">
          <span className="truncate max-w-[200px]">{row.originalName || 'Document'}</span>
          {/* {row.isApproved && (
            <span className="text-[9px] text-emerald-500 font-bold uppercase tracking-tighter flex items-center gap-0.5">
              <Check className="w-2.5 h-2.5" /> Approved
            </span>
          )} */}
        </div>
      </div>
    )
  },
  {
    header: 'Uploaded By',
    key: 'uploadedBy',
    render: (row) => (
      <div className="flex flex-col">
        <span className="text-[12px] font-medium text-slate-600 font-['Poppins']">
          {row.uploadedBy?.name || `${row.uploadedBy?.firstName || ''} ${row.uploadedBy?.lastName || ''}`.trim() || 'System'}
        </span>
        <span className="text-[10px] text-slate-400 font-medium">
          {row.uploadedBy?.email || ''}
        </span>
      </div>
    )
  },
  {
    header: 'Uploaded Date',
    key: 'uploadedAt',
    render: (row) => (
      <span className="text-[11px] font-medium text-slate-500 font-['Poppins']">
        {row.uploadedAt ? new Date(row.uploadedAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
      </span>
    )
  },
  {
    header: 'Action',
    key: 'action',
    className: 'text-center',
    render: (row) => (
      <div className="flex items-center justify-center gap-2">
        {/* {!row.isApproved && onApprove && (
          <TableActionButton 
            icon={Check} 
            variant="success" 
            onClick={() => onApprove(row)}
            title="Approve"
          />
        )} */}
        <TableActionButton
          icon={Eye}
          variant="primary"
          onClick={() => onView && onView(row)}
          title="View"
        />
        <TableActionButton
          icon={Download}
          variant="success"
          onClick={() => onDownload && onDownload(row)}
          title="Download"
        />
        {/* <TableActionButton 
          icon={Trash2} 
          variant="danger" 
          onClick={() => onDelete && onDelete(row)}
          title="Delete"
        /> */}
      </div>
    )
  }
];
